import React from 'react';
import { useTheme } from '../context/ThemeContext';

/**
 * Selltrix wordmark/icon. `variant="white"` is for dark surfaces,
 * `variant="blue"` is for light surfaces, `variant="icon"` renders just the
 * square X mark. When no `variant` is passed, it follows the active theme
 * so the same call site works on both a white and a navy background.
 */
export default function BrandLogo({ variant, className = 'h-7', alt = 'Selltrix' }) {
  const { isDark } = useTheme();
  const resolvedVariant = variant || (isDark ? 'white' : 'blue');
  const sources = {
    white: '/brand/selltrix-wordmark-white.png',
    blue: '/brand/selltrix-wordmark-blue.png',
    icon: '/brand/selltrix-icon-blue.png',
  };

  return (
    <img
      src={sources[resolvedVariant] || sources.white}
      alt={alt}
      className={`${className} w-auto select-none`}
      draggable={false}
    />
  );
}
